export const filterUseCasesBySegment = (useCases, customerSegment) => {
    if (!customerSegment) {
        return useCases;
    }
    return Object.entries(useCases).reduce((filtered, [key, useCase]) => {
        if (!('customersegment' in useCase) || useCase.customersegment === customerSegment) {
            filtered[key] = useCase;
        }
        return filtered;
    }, {});
};

export const getSurveyTitleById = (id, surveyConfig) => {
    const foundSurvey = surveyConfig.find(survey => survey.id === id);
    return foundSurvey ? foundSurvey.config.title : id;
};

export const getFilterLabel = (value, type, { surveyConfig, useCaseData, customerSegment, intl }) => {
    switch (type) {
        case 'useCases':
            const filteredUseCases = filterUseCasesBySegment(useCaseData, customerSegment);
            return intl.formatMessage({
                id: `usecase.${value}.title`,
                defaultMessage: filteredUseCases[value]?.title || value,
            });

        case 'surveys':
            return getSurveyTitleById(value, surveyConfig);

        case 'campaigns':
        case 'locations':
        case 'degrees':
        case 'groups':
            return value;

        default:
            return value;
    }
};

export const getFilterTitle = (value, type, { surveyConfig, useCaseData, customerSegment, intl }) => {
    switch (type) {
        case 'useCases':
            const filteredUseCases = filterUseCasesBySegment(useCaseData, customerSegment);
            return intl.formatMessage({
                id: `usecase.${value}.description`,
                defaultMessage: filteredUseCases[value]?.description || value,
            });

        case 'surveys':
        case 'campaigns':
        case 'locations':
        case 'degrees':
        case 'groups':
            return value;

        default:
            return value;
    }
}

export const formatDateRange = (dateRangeStr, intl) => {
    if (!dateRangeStr?.[0]) return '';

    const [startDate, endDate] = dateRangeStr[0].split('_').map(date => new Date(date));
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();

    return startYear === endYear
        ? `${startDate.toLocaleDateString(intl.locale, { month: 'short' })}–${endDate.toLocaleDateString(intl.locale, { month: 'short' })} ${endYear}`
        : `${startDate.toLocaleDateString(intl.locale, { month: 'short' })} ${startYear}–${endDate.toLocaleDateString(intl.locale, { month: 'short' })} ${endYear}`;
};